module.exports = __webpack_public_path__ + "img/instagram.be5c1884.svg";